import { render, staticRenderFns } from "./addKeywordPage.vue?vue&type=template&id=e45cbc5c&scoped=true"
import script from "./addKeywordPage.vue?vue&type=script&lang=js"
export * from "./addKeywordPage.vue?vue&type=script&lang=js"
import style0 from "./addKeywordPage.vue?vue&type=style&index=0&id=e45cbc5c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e45cbc5c",
  null
  
)

export default component.exports